<template lang="pug">
  .result
    picture
      source(:srcset="`${rt}img/pc/result/r${current}.png`"  media='(min-width: 768px)')
      img(:srcset="`${rt}img/result/r${current}.png`")
    .sns
      .sns-base: picture
        source(:srcset="`${rt}img/pc/result/sns.png`" media='(min-width: 768px)')
        img(:srcset="`${rt}img/result/sns.png`")
      a.fb(
        :href="`https://www.facebook.com/sharer/sharer.php?u=https://earth-mall.jp/beauties_shindan/share/result${current}/`"
        target="_blank"
        rel="nofollow noopener noreferrer"): picture
        source(:srcset="`${rt}img/result/fb.png`" media='(min-width: 768px)')
        img(:srcset="`${rt}img/result/fb.png`")
      a.tw(
        rel="nofollow noopener noreferrer"
        :href="`https://twitter.com/intent/tweet?text=${info[this.current].description}&hashtags=${info[this.current].hashtags}&url=https://earth-mall.jp/beauties_shindan/share/result${current}/`"
        target="_blank"): picture
        source(:srcset="`${rt}img/result/tw.png`" media='(min-width: 768px)')
        img(:srcset="`${rt}img/result/tw.png`")
    .relation
      template(v-if="current==='1'")
        router-link.lnk(
          to="/result5/"
          :style="{left: '32%', width: '40%'}"
          )
      template(v-if="current==='2'")
        router-link.lnk(
          to="/result3/"
          :style="{left: '10%', width: '40%'}"
        )
        router-link.lnk(
          to="/result4/"
          :style="{left: '52%', width: '33%'}"
        )
      template(v-if="current==='3'")
        router-link.lnk(
          to="/result2/"
          :style="{left: '11%', width: '39%'}"
        )
        router-link.lnk(
          to="/result4/"
          :style="{left: '52%', width: '33%'}"
        )
      template(v-if="current==='4'")
        router-link.lnk(
          to="/result2/"
          :style="{left: '7%', width: '39%'}"
        )
        router-link.lnk(
          to="/result3/"
          :style="{left: '46%', width: '38%'}"
        )
      template(v-if="current==='5'")
        router-link.lnk(
          to="/result1/"
          :style="{left: '33%', width: '40%'}"
        )
</template>

<script>
const info = require('../info.json')
export default {
  props: ['rt'],
  computed: {
    current () {
      return this.$route.path.replace('result', '').replace(/\//g, '')
    }
  },
  data () {
    return {
      info
    }
  },
  mounted () {
    console.log(this.$route.path)
  }
}
</script>

<style lang="scss" scoped>
.result {
  width: 97%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 7%;
  position: relative;
  img {
    width: 100%;
  }
}
@media screen and (min-width:768px) {
  .result {
    max-width: 1170px;
    margin-bottom: 30px;
  }
}
.sns {
  position: absolute;
  width: 83%;
  left: 50%;
  transform: translateX(-50%);
  bottom: 1.8%;
  .sns-base {
  }
  .fb {
    position: absolute;
    width: 12%;
    top: 50%;
    left: 64%;
    transform: translateY(-50%);
  }
  .tw {
    position: absolute;
    width: 12%;
    top: 50%;
    left: 80%;
    transform: translateY(-50%);
  }
}

@media screen and (min-width:768px) {
  .sns {
    width: 36.326%;
    left: 50%;
    transform: none;
    bottom: 4.4%;
    .fb {
      transition: opacity 0.2s ease;
      opacity: 1;
      &:hover {
        transition: opacity 0.2s ease;
        opacity: 0.8;
      }
    }
    .tw {
      transition: opacity 0.2s ease;
      opacity: 1;
      &:hover {
        transition: opacity 0.2s ease;
        opacity: 0.8;
      }
    }
  }
}

.relation {
  position: absolute;
  bottom: 8%;
  left: 50%;
  transform: translateX(-50%);
  width: 85%;
  padding-top: 22%;
  //background-color: rgba(255, 0, 0, 0.4);
  .lnk {
    //background-color: rgba(0, 255, 0, 0.4);
    position: absolute;
    left: 50%;
    top: 0%;
    width: 20%;
    height: 100%;
  }
}
@media screen and (min-width:768px) {
  .relation {
    transform: none;
    bottom: 4%;
    left: 13%;
    width: 35%;
    padding-top: 10%;
    .lnk {
      transition: opacity 0.2s ease;
      background-color: white;
      opacity: 0;
      &:hover {
        transition: opacity 0.2s ease;
        opacity: 0.2;
      }
    }
  }
}
</style>
